import React from "react";
import { Helmet } from 'react-helmet-async';

export default function CookiePolicy() {
  return (
    <div className="min-h-screen py-12 px-6 lg:px-24">
      <Helmet>
        <title>Cookie Policy — Andlegur</title>
        <meta name="description" content="Learn how Andlegur uses cookies to improve your experience. Read our Cookie Policy for details on cookie types and your choices." />
        <link rel="canonical" href="https://andlegur.com/cookie-policy" />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <div className="max-w-4xl mx-auto shadow-xl rounded-2xl p-10">
        <h1 className="text-4xl font-bold text-indigo-200 mb-6">
          Cookie Policy
        </h1>
        <p className="text-indigo-100 mb-8">
          This Cookie Policy explains how Andlegur (“Company,” “we,” “our,” or
          “us”) uses cookies and similar tracking technologies when you visit
          our website, applications, and services (“Services”). By using our
          Services, you agree to the use of cookies as described in this policy.
        </p>

        <h2 className="text-2xl font-semibold text-indigo-100 mb-4">1. What Are Cookies?</h2>
        <p className="text-indigo-100 mb-6">
          Cookies are small text files that are stored on your device when you
          visit a website. They help us improve your experience by remembering
          your preferences, analyzing site traffic, and enabling certain
          features.
        </p>

        <h2 className="text-2xl font-semibold text-indigo-100 mb-4">2. Types of Cookies We Use</h2>
        <ul className="list-disc pl-6 text-indigo-100 mb-6 space-y-2">
          <li><strong>Essential Cookies:</strong> Required for the basic operation of our Services.</li>
          <li><strong>Performance Cookies:</strong> Help us understand how users interact with our Services.</li>
          <li><strong>Functional Cookies:</strong> Remember your settings and preferences.</li>
          <li><strong>Advertising Cookies:</strong> Track browsing habits to deliver relevant ads (used by us and third parties).</li>
        </ul>

        <h2 className="text-2xl font-semibold text-indigo-100 mb-4">3. Third-Party Cookies</h2>
        <p className="text-indigo-100 mb-6">
          Some cookies are set by third-party providers, including analytics and
          advertising partners. These providers may collect information about
          your online activities across different websites and services.
        </p>

        <h2 className="text-2xl font-semibold text-indigo-100 mb-4">4. Managing Cookies</h2>
        <p className="text-indigo-100 mb-6">
          You can manage cookies through your browser settings. Please note that
          disabling cookies may affect the functionality of our Services.
        </p>

        <h2 className="text-2xl font-semibold text-indigo-100 mb-4">5. Updates to This Policy</h2>
        <p className="text-indigo-100 mb-6">
          We may update this Cookie Policy from time to time. The updated
          version will be indicated by an updated “Last Updated” date at the top
          of the privacy policy page.
        </p>

        <p className="text-indigo-100">
          For more information on how we collect and use data, please see our{" "}
          <a href="/privacy" className="text-indigo-300 font-semibold hover:underline">
            Privacy Policy
          </a>.
        </p>
      </div>
    </div>
  );
}
